import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../contexts';
import { submitFaq } from './actions';
import FormFaq from './FormFaq';
import FormFaqSubpangkalan from './FormFaqSubpangkalan';

export default function Form() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { setBreadcrumbs } = useContext(AppContext);
  const [afterSubmit, setAfterSubmit] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get('type') || 'pangkalan';

  const { dataSubmitFaq, isLoadingSubmitFaq, messageSubmitFaq } = useSelector(
    (s) => s.faq
  );

  useEffect(() => {
    setBreadcrumbs([
      'Pengaturan FAQ',
      `Buat FAQ ${type === 'subpangkalan' ? 'Subpangkalan' : ''}`,
    ]);
  }, []);

  useEffect(() => {
    if (afterSubmit && !isLoadingSubmitFaq) {
      if (messageSubmitFaq === '') {
        navigate(`/faq?tab=${type}`);
      }
    }
  }, [dataSubmitFaq, isLoadingSubmitFaq]);

  if (type === 'subpangkalan') {
    return (
      <FormFaqSubpangkalan
        onSubmit={(values) =>
          dispatch(submitFaq({ ...values, type }, () => setAfterSubmit(true)))
        }
      />
    );
  }

  return (
    <FormFaq
      onSubmit={(values) =>
        dispatch(submitFaq({ ...values, type }, () => setAfterSubmit(true)))
      }
    />
  );
}
